import './App.css';
import React from 'react';
import Login from './Login';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Api from './Api';
import TabPanel from './TabPanel';
import User from './User';
import ScheduleUsers from './ScheduleUsers';
import ConfigureRemoteAccess from './ConfigureRemoteAccess';
import Header from './Header';
import SignOut from './SignOut';
import { MuiThemeProvider } from '@material-ui/core/styles';
import theme from './theme';


function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      beamlines: [],
      success: null,  // null means loading, true means success, false means error
      errorMessage: ""
    };
  }

  componentDidMount() {
    const old_token = localStorage.getItem("token");
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let token = urlParams.get("token");

    // Save the token if found in URL parameters
    if (token) {
      localStorage.setItem("token", token);
    } else if (old_token) {
      token = old_token;
    }

    // Set error state if token is not present
    if (!token) {
      this.setState({ success: false, errorMessage: "No token found." });
      return;
    }

    // Clear the URL query parameters after storing the token
    window.history.replaceState({}, document.title, "/");

    // Fetch user data
    this.fetchUserData();
  }

  fetchUserData = async () => {
    try {
      const res = await Api.get("/api/get/user_data");
      if (!res.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await res.json();
      if (data.name === "Invalid Operation") {
        throw new Error("Invalid Operation");
      } else {
        this.setState({ name: data.name, beamlines: data.beamlines, success: true });
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      this.setState({ success: false, errorMessage: "Failed to fetch user data." });
    }
  };

  render() {
    document.title = 'Remote ALS';
    const { success, name, beamlines, errorMessage } = this.state;

    // // Show a loading indicator while checking the token and fetching user data
    // if (success === null) {
    //   return <div>Loading...</div>;
    // }

    // Render the Login component if there was an error or no token
    if (!success) {
      return (
        <MuiThemeProvider theme={theme}>        
          <main>
            <Header />
            <Login />
          </main>
        </MuiThemeProvider>
      )
    } else {
      return (
        <MuiThemeProvider theme={theme}> 
        <div>
          <MainTabs uname={name} ubeamlines={beamlines} />
        </div>
        </MuiThemeProvider>
      );
    }
    }

}

function MainTabs(props) {
  const { uname, ubeamlines } = props;
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const isManager = ubeamlines.length > 0;
  const isJupyter = ubeamlines.includes("8.3.2");
  const counter = isManager ? 2 : 0;

  return (
    <main>
      <SignOut /> {/* absolute positioned for use with a modal popup */}

      <Header />

      <nav>
        <Tabs orientation="horizontal" variant="scrollable" value={value} onChange={handleChange} style={{justifyContent: "space-between"}}>
          <Tab style={{ textTransform: "none", fontSize: 16, fontWeight: "bold", whiteSpace: 'pre-line', marginRight: '2rem' }} label={`Access Resources For\n${uname}`} {...a11yProps(0)} />
          {isManager && <Tab style={{ textTransform: "none", fontSize: 16, fontWeight: "bold", whiteSpace: 'pre-line', marginRight: '2rem' }} label={"Schedules\nAccess"} {...a11yProps(1)} />}
          {isManager && <Tab label={"Configure\nRemote Resources"} style={{ textTransform: "none", fontSize: 16, fontWeight: "bold", whiteSpace: 'pre-line', marginRight: '2rem' }} {...a11yProps(2)} />}
          {isJupyter && <TabPanel value={value} index={3 - counter}> <div>Check New Link...</div> </TabPanel>}
        </Tabs>
      </nav>

      <section>
        <TabPanel value={value} index={0}> <User /> </TabPanel>
        {isManager && <TabPanel value={value} index={1}> <ScheduleUsers beamlines={ubeamlines} /> </TabPanel>}
        {isManager && <TabPanel value={value} index={2}> <ConfigureRemoteAccess beamlines={ubeamlines} /> </TabPanel>}
      </section>

    </main>
  );
}

MainTabs.propTypes = {
  uname: PropTypes.any.isRequired,
  ubeamlines: PropTypes.any.isRequired,
};

export default App;
